import "./CompletedCourses.css";
import Container from "react-bootstrap/Container";
import { Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import React, { useState, useEffect } from "react";
import { fetchUserCertificates } from "../../Providers/CatalogDataService";

const CompletedCourses = () => {
  const [certificates, setCertificates] = useState([]);
  useEffect(() => {
    fetchUserCertificates().then((res) => setCertificates(res));
  }, []);
  return (
    <div className="card-container">
      <div className="container">
        <div className="arrow-course">
          <a href="#">
            <img src="assets/images/arrowLeft.png" />
          </a>
        </div>
        <div className="row">
          <div className="col-2 text-start">
            <div className="launch-course">Launchified</div>
          </div>
          <div className="w-100"></div>
          <div className="col-9 text-start">
            <div className="completed-courses">Completed courses</div>
          </div>
        </div>
        <br />
      </div>
      <br></br>
      <Container className="completedCourses-container">
        <Row className="g-3 g-lg-5 row-cols-1 row-cols-xs-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-3">
          {certificates.map((certificates, key) => (
            <div className="col" key={key}>
              <Card
                className=" mx-0 rounded  bg-light"
                style={{ width: "20rem", height: "15rem" }}
              >
                <Card.Img
                  className="img-cert"
                  variant="top"
                  src="Nttdata_Top.png"
                  fluid
                />
                <Card.Body>
                  <span className="courseTitle">
                    {certificates.courseName || []}
                  </span>
                </Card.Body>
              </Card>
            </div>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default CompletedCourses;
